import { FinanceFinancialWorkspacePaceDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useFinancialWorkspaceSeeAgreements = () => {
  const { data } = useQuery(FinanceFinancialWorkspacePaceDocument)

  const canSeeFinanceWorkspace = data?.financialWorkspace._policies.seeFinancialWorkspace.can

  return {
    canSeeFinanceWorkspace,
  }
}
